<script setup lang="ts">
  import type { ButtonHTMLAttributes } from 'vue'
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    to?: RouteLocationRaw,
    loading?: boolean,
    disabled?: boolean,
    type?: ButtonHTMLAttributes['type'],
    href?: string,
  }>()

  // styles handled by @assets/styles/button.css
</script>

<template>
  <router-link
    v-if="!disabled && !loading && to"
    :to="to">
    <slot></slot>
  </router-link>
  <a
    v-else-if="!disabled && !loading && href"
    :href="href"
    :target="href ? '_blank' : undefined">
    <slot></slot>
  </a>
  <button
    v-else
    class="disabled:cursor-not-allowed"
    :class="{'btn-is-loading': loading}"
    :type="type ?? 'button'"
    :disabled="disabled || loading">
    <slot></slot>
    <span
      v-if="loading"
      class="absolute m-auto text-gray-400 leading-none">
      <fa-icon
        icon="i-far-circle-notch"
        class="animate-spin" />
    </span>
  </button>
</template>

<style scoped>
  .btn-is-loading:disabled {
    color: transparent!important;
  }
</style>
